#import "../../../../graphql-wrappers/broadcast/graphql/fragments/broadcast-fragment.graphql"

mutation GenerateAiEmailTemplate($input: AiEmailTemplateGenerateInput!) {
    aiEmailTemplateGenerate(input: $input) {
        campaign {
            ...BroadcastFragment
        }
    }
}
